import React from 'react';
import CustomDialog from 'widgets/component/CustomDialog';

const TokuMessageDialog = ({ open, onClose, dialogMessage }) => {
  return (
    <CustomDialog
      title='Mensaje'
      content={<p>{dialogMessage}</p>}
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='sm'
      extraButtons={[
        {
          label: 'Aceptar',
          variant: 'contained',
          onClick: onClose,
          buttonColor: 'purple',
          textColor: 'white',
        },
      ]}
    />
  );
};

export default TokuMessageDialog;
